(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["gdprGuardLocal"] = factory();
	else
		root["gdprGuardLocal"] = factory();
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : this, function() {
return 